module.exports = __webpack_public_path__ + "media/images/top/works07-4d583af65f1b37e5e62ac846bf2bc874.jpg";